var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3133 0H1.53916C1.13095 0 0.739459 0.152182 0.45081 0.423068C0.162161 0.693954 0 1.06135 0 1.44444V4.33333C0 4.71642 0.162161 5.08382 0.45081 5.35471C0.739459 5.6256 1.13095 5.77778 1.53916 5.77778H12.3133C12.7215 5.77778 13.113 5.6256 13.4016 5.35471C13.6903 5.08382 13.8525 4.71642 13.8525 4.33333V1.44444C13.8525 1.06135 13.6903 0.693954 13.4016 0.423068C13.113 0.152182 12.7215 0 12.3133 0ZM1.53916 4.33333V1.44444H12.3133V4.33333H1.53916Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15665 6.5H1.53916C1.13095 6.5 0.739459 6.65218 0.45081 6.92307C0.162161 7.19395 0 7.56135 0 7.94444V11.5556C0 11.9386 0.162161 12.306 0.45081 12.5769C0.739459 12.8478 1.13095 13 1.53916 13H6.15665C6.56486 13 6.95635 12.8478 7.245 12.5769C7.53365 12.306 7.69581 11.9386 7.69581 11.5556V7.94444C7.69581 7.56135 7.53365 7.19395 7.245 6.92307C6.95635 6.65218 6.56486 6.5 6.15665 6.5ZM1.53916 11.5556V7.94444H6.15665V11.5556H1.53916Z",
    fill: "#313131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3167 6.5H10.0079C9.5997 6.5 9.20821 6.65218 8.91956 6.92307C8.63091 7.19395 8.46875 7.56135 8.46875 7.94444V11.5556C8.46875 11.9386 8.63091 12.306 8.91956 12.5769C9.20821 12.8478 9.5997 13 10.0079 13H12.3167C12.7249 13 13.1164 12.8478 13.405 12.5769C13.6937 12.306 13.8558 11.9386 13.8558 11.5556V7.94444C13.8558 7.56135 13.6937 7.19395 13.405 6.92307C13.1164 6.65218 12.7249 6.5 12.3167 6.5ZM10.0079 11.5556V7.94444H12.3167V11.5556H10.0079Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.3208e2d37639120cd91039ae1809857c.svg";
export { ForwardRef as ReactComponent };